import React, { useEffect } from "react";
import {useAuth0} from "@auth0/auth0-react";
import {useState} from "@hookstate/core";
import {editUser, getUserData} from "../../Services/ApiService";
import {Button, Form} from "react-bootstrap";

import './UserProfile.scss';

const UserProfile = () => {
    const { user, isAuthenticated } = useAuth0();
    const displayName = useState('');
    const savedNotifIsHidden = useState(true);

    useEffect(() => {
        getUserData(user.sub, _user => {
            displayName.set(_user.name);
        })

    // eslint-disable-next-line
    }, []);

    function SubmitNameChange() {
        editUser({id: user.sub, name: displayName.get()}, _ => {});

        savedNotifIsHidden.set(false);

        setTimeout(() => {
            savedNotifIsHidden.set(true);
        }, 3000)
    }

    return (
        isAuthenticated && (
            <div id={'userProfile'}>
                <p>Email: {user.email}</p>
                <Form.Control id={'username'}
                              onChange={e => displayName.set(e.target.value)}
                              value={displayName.get()}
                              placeholder={'Displayed Name'}
                />
                <div id={"formSubmission"}>
                    <Button onClick={SubmitNameChange}>Save</Button>
                    <p id={`savedNotification-${savedNotifIsHidden.get()}`}>Changes Saved!</p>
                </div>
            </div>
        )
    );
};

export default UserProfile;